import { createUseStyles } from 'react-jss'
import MainHero from '@/components/MainHero'

import style from './style'

const useStyles = createUseStyles(style)

const Cover = ({
  title,
  img,
  ready,
}) => {
  const classes = useStyles()
  return (title && img) && (
    <MainHero
      className={classes.hero}
      title={title}
      img={img}
      ready={ready}
      scrollIcon
      parallax
      delay={1}
      layout="bottom"
      plainFont
    />
  )
}

export default Cover
